module.exports = __webpack_public_path__ + "img/avatar-rectangle.661d22ee.png";